import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import classNames from 'classnames';

import styles from './styles';

function ADGMResponsiveModal(props) {
  const { classes, customClasses, open, toggleModal, title, rightAction, children, mandatory, ...otherProps } = props;

  return (
    <Modal
      aria-labelledby='adgm-modal-title'
      aria-describedby='adgm-modal-description'
      open={open}
      onClose={toggleModal}
      disableScrollLock
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      {...otherProps}
    >
      <Fade in={open}>
        <div className={classNames(classes.modal, classes.modalPaper, customClasses?.modal)}>
          <div className={classNames(classes.modalTitleHead, customClasses?.header)}>
            <IconButton aria-label='back' className={classes.backIconBtn} onClick={toggleModal}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant='h6' component='h1'>
              {title} {mandatory && <span className={classes.requiredStar}>*</span>}
            </Typography>
            {rightAction ? (
              <div className={classes.rightAction}>{cloneElement(rightAction)}</div>
            ) : (
              <IconButton aria-label='close' className={classes.crossIconBtn} onClick={toggleModal}>
                <CloseIcon />
              </IconButton>
            )}
          </div>
          <div className={classNames(classes.modalBody, customClasses?.content)}>{children}</div>
        </div>
      </Fade>
    </Modal>
  );
}

ADGMResponsiveModal.propTypes = {
  classes: PropTypes.object.isRequired,
  customClasses: PropTypes.object,
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rightAction: PropTypes.node,
  mandatory: PropTypes.bool,
};

ADGMResponsiveModal.defaultProps = {
  toggleModal: null,
  customClasses: null,
  title: null,
  rightAction: null,
  mandatory: false,
};

export default withStyles(styles)(ADGMResponsiveModal);
